module.exports = __webpack_public_path__ + "static/media/graphdb.d1d377eb.png";